export default __webpack_public_path__ + "static/media/property_497.9a33a057.png";